// import { getServerVersion } from '../../../api/services';
import {
  isEnvPre,
  // isEnvProd,
} from '../../../config';
import {
  getLocaleLanguage,
  LanguageType,
  parseVariablePath,
  strToJson,
} from '../../../lib';
import {
  IAPIGameItem,
  IAPIServiceConfigItem,
  IAPIUserInfo,
  ServiceBusiness,
} from '../../../model/api-modules';
import { IGameEnvModel } from '../../../model/api-modules/env';
import { getLoginToken } from '../../lib';
enum CustomType {
  Astride = 'astride', // 跨周 跨月
  Inside = 'inside', // 本周 本月
}

interface IDefinition {
  readonly startTime: Record<string, number>;
  readonly endTime: Record<string, number>;
  readonly customType: CustomType;
}
interface ITimeConfig {
  userTimeZone?: string; // 用户时区
  weekDefinition?: IDefinition; // 周定义
  monthDefinition?: IDefinition; // 月定义
  timeZone?: string; // 生效时区
}
export const mergeURLParams = (
  studioID: string,
  gameID: string,
  envGuid: string,
  selectGame: IAPIGameItem | undefined,
  userInfo: IAPIUserInfo | null
) => {
  const token = getLoginToken();
  const lang = getLocaleLanguage() || LanguageType.en_US;
  const pre = isEnvPre() ? '&gcloud_env=pre' : '';
  let timeConfig: ITimeConfig = {};
  const gameExtensionField = JSON.parse(selectGame?.gameExtensionField || '{}');
  const gameDefinition = Object.assign(
    {},
    gameExtensionField.frequency_definition
  );
  if (Object.keys(gameDefinition).length !== 0) {
    timeConfig = {
      ...gameDefinition,
    };
  }
  if (userInfo?.UserSettings?.Timezone) {
    timeConfig.userTimeZone = userInfo?.UserSettings?.Timezone;
  }
  return `?ticket=${token}&studioid=${studioID}&gameid=${gameID}&envid=${envGuid}&from=gos${pre}&lang=${lang}&timeConfig=${encodeURIComponent(
    JSON.stringify(timeConfig)
  )}`;
};

export const getGosHostname = (params?: string) => {
  const data = strToJson<{ EnvURL: string }>(params || '{}');
  const envURL = data?.EnvURL;
  return envURL;
};

const decodeEntities = (encodedString: string): string => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(encodedString, 'text/html');
  return doc.body.textContent || '';
};

// export const getGameEnvIframeURL = async (
export const getGameEnvIframeURL = (
  serviceConfig: IAPIServiceConfigItem,
  env: IGameEnvModel,
  gameID: string,
  studioID: string,
  selectGame: IAPIGameItem | undefined,
  userInfo: IAPIUserInfo | null
) => {
  const params = mergeURLParams(
    studioID,
    gameID,
    env.Guid,
    selectGame,
    userInfo
  );

  if (
    serviceConfig.Business === ServiceBusiness.Bianque &&
    env.Guid === '40725408-4-Development-DEV'
  ) {
    return decodeEntities(`https://cn-bq.ingame.tencent.com:12030${params}`);
  }

  let pathname = '';
  let hostname: string | undefined = undefined;
  if (serviceConfig.Business === ServiceBusiness.G6) {
    hostname = getGosHostname(env.GosParams);
    pathname = parseVariablePath(serviceConfig.ServicePath, {
      gameId: gameID,
    });
    // 1.14增加版本号后使用
    // const res = await getServerVersion(gameID, env.id, env.Guid);
    // if (res?.result?.server_version) {
    //   pathname = `/${res?.result?.server_version}${parseVariablePath(
    //     serviceConfig.ServicePath,
    //     { gameId: gameID }
    //   )}`;
    // } else {
    //   pathname = parseVariablePath(serviceConfig.ServicePath, {
    //     gameId: gameID,
    //   });
    // }
  }
  if (
    serviceConfig.Business === ServiceBusiness.Currency ||
    serviceConfig.Business === ServiceBusiness.GCloud
  ) {
    hostname = serviceConfig.ServicePath;
  }
  if (serviceConfig.Business === ServiceBusiness.DMP) {
    hostname = parseVariablePath(serviceConfig.ServicePath, { gameId: gameID });
  }
  if (serviceConfig.Business === ServiceBusiness.Bianque) {
    if (env.BianqueParams) {
      hostname = getGosHostname(env.BianqueParams);
    } else {
      hostname = serviceConfig.ServicePath;
    }
  }

  if (hostname) {
    return decodeEntities(`${hostname}${pathname}${params}`);
  }
  return null;
};

export const getIframeRectStyle = () => {
  try {
    let adaptWidth = window.innerWidth;
    const docWidth = document.documentElement.clientWidth;
    if (adaptWidth < docWidth) {
      adaptWidth = docWidth;
    }
    let adaptHeight = window.innerHeight;
    const docHeight = document.documentElement.clientHeight;
    if (adaptHeight < docHeight) {
      adaptHeight = docHeight;
    }

    const noticeElement = document.querySelector(
      '.gc-page-headline .global-notice-console'
    ) as HTMLElement | undefined;

    const noticeHeight = noticeElement?.offsetHeight || 0;

    return {
      width: `${adaptWidth - 64}px`,
      height: `${adaptHeight - 60 - noticeHeight}px`,
    };
  } catch (error) {
    return null;
  }
};
